<template>
  <p
    class="text_drag"
    :style="{
      top: text.top,
      left: text.left,
      'font-weight': text.style['font-weight'],
      'font-style': text.style['font-style'],
      'font-family': text.style['font-family'],
      'font-size': text.style['font-size'],
      color: text.style.color,
      'text-decoration': text.style['text-decoration'],
      transform: text.style.transform,
      cursor: !text.editable ? 'move' : 'text',
    }"
    :id="'draggable_' + text.id"
  >
    {{ text.content }}
  </p>
</template>

<script>
export default {
  props: {
    text: { type: Object, required: true },
  },
  setup(props, context) {
    function changeContent(event) {
      context.emit("changeContent", event.target.innerText);
    }

    return {
      changeContent,
    };
  },
};
</script>

<style lang="scss" scoped>
.text_drag {
  z-index: 100;
  position: absolute;
}
</style>
